import React from 'react'
import { Box, Button, Stack, Typography } from '@mui/material'
import { buzzerButton, neonText, TV_COLORS } from '../designSystem'

type FinalIntroProps = {
  countdown: number | null
  onStart: () => void
}

const FinalIntro = ({ countdown, onStart }: FinalIntroProps) => {
  const showCountdown = countdown != null

  return (
    <Box
      sx={{
        textAlign: 'center',
        py: 4,
        border: '2px solid rgba(255,255,255,0.2)',
        borderRadius: 2,
        background: 'rgba(0,0,0,0.4)',
        boxShadow: '0 0 25px rgba(0,0,0,0.45)',
      }}
    >
      <Typography
        variant="h4"
        sx={{ fontFamily: 'Bebas Neue', ...neonText(TV_COLORS.yellow), mb: 1.5 }}
      >
        Êtes-vous prêt ?
      </Typography>
      <Typography variant="body2" sx={{ mb: 3, color: 'rgba(255,255,255,0.8)' }}>
        La finale va commencer, respire un coup et prépare-toi à deviner le juste prix.
      </Typography>

      {showCountdown ? (
        <Stack spacing={1} alignItems="center">
          <Typography variant="body2" color="text.secondary">
            Départ dans
          </Typography>
          <Typography variant="h2" sx={{ fontWeight: 700 }}>
            {countdown}
          </Typography>
        </Stack>
      ) : (
        <Button
          variant="contained"
          size="large"
          onClick={onStart}
          sx={{
            ...buzzerButton('higher', { base: TV_COLORS.blue, dark: TV_COLORS.violet }),
            width: '60%',
            mx: 'auto',
          }}
        >
          C’est parti !
        </Button>
      )}
    </Box>
  )
}

export default FinalIntro
